import { render, staticRenderFns } from "./docview.vue?vue&type=template&id=481a3110&scoped=true&"
import script from "./docview.vue?vue&type=script&lang=js&"
export * from "./docview.vue?vue&type=script&lang=js&"
import style0 from "./docview.vue?vue&type=style&index=0&id=481a3110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a3110",
  null
  
)

export default component.exports